import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { getRoleLabel } from "@ugg/shared/utils/role-helpers";
import { MediaQuery } from "@outplayed/responsive";

interface CommonProps extends RoleQuestRequirementsProps {
  className?: string;
}

interface RoleQuestRequirementsProps {
  role: string;
}

export default function RoleQuestRequirements(props: RoleQuestRequirementsProps) {
  const { role } = props;

  //TODO Make this update dynamicly based on a data point from data dragon as these are probably going to change each patch based on balancing
  const roleQuestJson = {
    adc: {
      quest_completion: 1350,
      minion_kill: 1.5,
      epic_monster: 30,
      turret: 25,
      turret_plate: 20,
      champion: 15,
    },
    mid: {
      quest_completion: 1350,
      minion_kill: 1,
      epic_monster: 30,
      turret: 25,
      turret_plate: 20,
      champion: 25,
    },
    top: {
      quest_completion: 1200,
      minion_kill: 1,
      epic_monster: 30,
      turret: 25,
      turret_plate: 20,
      champion: 15,
    },
  };
  type Role = keyof typeof roleQuestJson;

  const roleQuestRequirementsText = {
    support: `Upgrade your support item to complete your quest. Earn points by <span class="font-bold text-white">damaging enemy champions or turrets, or killing minions</span> (15 for caster and melee minions, 20 for cannon and siege minions) while near an ally. Earn points much faster in bot lane!`,
    jungle: `Upgrade your Jungle Pet to complete your quest. Earn progress by defeating <span class="font-bold text-white">jungle monsters</span>. Slay 35 epic monsters to fully upgrade your Jungle Pet.`,
  };

  const laneText: Record<string, string> = {
    top: `top lane`,
    jungle: `jungle`,
    mid: `mid lane`,
    adc: `bottom lane`,
    support: `bottom lane`,
  };

  return (
    <div className="bg-purple-400 p-[18px]">
      <div className="relative flex max-sm:grid max-sm:gap-2 items-center w-full mb-[18px]">
        <div className="max-sm:flex">
          <span className="absolute max-sm:relative left-0 w-[2px] h-[20px] rounded-[2px] bg-accent-blue-400"></span>
          <div className="font-inter text-[14px] font-bold text-white px-[12px]">Role Quest</div>
        </div>
        <div className="font-inter text-[14px] text-lavender-300 ">Extra power for the late game in {laneText[role]}</div>
      </div>
      <div className="bg-purple-200 rounded-[3px] p-[18px] w-full max-w-4xl mx-auto mb-[12px]">
        {role == "jungle" || role == "support" ? (
          <div className="text-[10px]" dangerouslySetInnerHTML={{ __html: roleQuestRequirementsText[role] }}></div>
        ) : (
          <div className="flex flex-row divide-x divide-accent-purple-700 text-left text-nowrap max-[600px]:flex-col max-[600px]:divide-x-0 max-[600px]:divide-y max-[600px]:text-center">
            <div className="pr-[18px] max-[600px]:pb-[18px] max-[600px]:pr-[0px] grow">
              <p className="font-inter text-[10px] font-medium text-lavender-50">Total Points</p>
              <p className="font-inter text-[14px] font-bold text-white">{roleQuestJson[role as Role].quest_completion}</p>
            </div>

            <div className="px-[18px] max-[600px]:py-[18px] max-[600px]:px-[0px] grow">
              <p className="font-inter text-[10px] font-medium text-lavender-50">Kills</p>
              <p className="font-inter text-[14px] font-bold text-white">{roleQuestJson[role as Role].champion}</p>
            </div>

            <div className="px-[18px] max-[600px]:py-[18px] max-[600px]:px-[0px] grow">
              <p className="font-inter text-[10px] font-medium text-lavender-50">Minions</p>
              <p className="font-inter text-[14px] font-bold text-white">{roleQuestJson[role as Role].minion_kill}</p>
            </div>

            <div className="px-[18px] max-[600px]:py-[18px] max-[600px]:px-[0px] grow">
              <p className="font-inter text-[10px] font-medium text-lavender-50">Plates</p>
              <p className="font-inter text-[14px] font-bold text-white">{roleQuestJson[role as Role].turret_plate}</p>
            </div>

            <div className="px-[18px] max-[600px]:py-[18px] max-[600px]:px-[0px] grow">
              <p className="font-inter text-[10px] font-medium text-lavender-50">Towers</p>
              <p className="font-inter text-[14px] font-bold text-white">{roleQuestJson[role as Role].turret}</p>
            </div>

            <div className="pl-[18px] max-[600px]:pt-[18px] max-[600px]:pl-[0px] grow">
              <p className="font-inter text-[10px] font-medium text-lavender-50">Epic Monsters</p>
              <p className="font-inter text-[14px] font-bold text-white">{roleQuestJson[role as Role].epic_monster}</p>
            </div>
          </div>
        )}
      </div>
      {role == "jungle" || role == "support" ? null : (
        <div className="text-lavender-50 font-inter text-[10px] font-medium">
          Earn more points while in the <span className="font-bold text-white">{laneText[role]}</span>.
        </div>
      )}
    </div>
  );
}
